// extracted by mini-css-extract-plugin
export default {"cls1":"lpuVvAEzHjYm3TzAiazA","cls2":"fS9GcflXjqPCAV1LcjjX lpuVvAEzHjYm3TzAiazA"};